function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useCallback, useContext, useLayoutEffect, useState } from 'react';
import { TabPortal } from 'react-tab-portal';
import { createPortal } from 'react-dom';
import throttle from '../../utils/throttle';
import './FilterBox.css';
import FilterBoxFixedContainerContext from './FilterBoxFixedContainerContext';
import ThemeContext from '../../ThemeContext';
function FilterBox(_ref) {
  var children = _ref.children,
    className = _ref.className,
    buttonRef = _ref.buttonRef,
    expanded = _ref.expanded,
    id = _ref.id,
    forwardedRef = _ref.forwardedRef,
    onBlur = _ref.onBlur,
    attrs = _objectWithoutProperties(_ref, ["children", "className", "buttonRef", "expanded", "id", "forwardedRef", "onBlur"]);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    style = _useState2[0],
    setStyle = _useState2[1];
  var context = useContext(FilterBoxFixedContainerContext);
  var theme = useContext(ThemeContext);
  useLayoutEffect(function () {
    var callback = throttle(function () {
      var forwardRef = forwardedRef;
      var ref = forwardRef && forwardRef.current;
      var button = theme === 'ripple' ? buttonRef && buttonRef.current && buttonRef.current.parentNode : buttonRef && buttonRef.current;
      if (expanded && ref && button) {
        var windowWidth = (window.visualViewport || {}).width || window.innerWidth;
        var windowHeight = (window.visualViewport || {}).height || window.innerHeight;
        var containerWidth = context && context.current ? context.current.getBoundingClientRect().right : windowWidth;
        var right = windowWidth - containerWidth + 2;
        var _ref$getBoundingClien = ref.getBoundingClientRect(),
          width = _ref$getBoundingClien.width,
          height = _ref$getBoundingClien.height;
        var _button$getBoundingCl = button.getBoundingClientRect(),
          bottom = _button$getBoundingCl.bottom,
          left = _button$getBoundingCl.left;
        var _style = {};
        if (left + width > containerWidth) {
          Object.assign(_style, {
            left: 'auto',
            right: "".concat(right, "px"),
            top: "".concat(bottom, "px")
          });
        } else {
          Object.assign(_style, {
            left: "".concat(left, "px"),
            right: 'auto',
            top: "".concat(bottom, "px")
          });
        }
        if (bottom + height > windowHeight) {
          Object.assign(_style, {
            top: "".concat(windowHeight - height, "px"),
            zIndex: 5001
          });
        }
        setStyle(_style);
      }
    }, 50);
    callback();
    window.addEventListener('scroll', callback, false);
    window.addEventListener('resize', callback, false);
    return function () {
      window.removeEventListener('scroll', callback);
      window.removeEventListener('resize', callback);
      setStyle(undefined);
    };
  }, [context, expanded, forwardedRef, buttonRef]);
  var handleBlur = useCallback(function () {
    setTimeout(function () {
      onBlur &&
      // @ts-ignore
      onBlur({
        relatedTarget: document.activeElement
      });
    }, 50);
  }, [onBlur]);
  if (expanded) {
    return createPortal(/*#__PURE__*/React.createElement("div", Object.assign({
      ref: forwardedRef,
      className: "filter-box filter-box--fixed ".concat(className),
      id: id,
      tabIndex: -1,
      onBlur: handleBlur,
      style: style
    }, attrs), /*#__PURE__*/React.createElement(TabPortal.Content, null, children)), document.body);
  }
  return null;
}
export default forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TabPortal, null, props.expanded && /*#__PURE__*/React.createElement(TabPortal.Portal, null), /*#__PURE__*/React.createElement(FilterBox, Object.assign({}, props, {
    forwardedRef: ref
  })));
});